export const Claims = {
  AdminReportingView: "admin.reporting.view",
};
